export class ColorHelper {
  // #FFFFFF のような文字列と、alpha値を受け取ってrgba(255,255,255,1.0)を返却する
  public static convertToRGBAString(hex16rgb: string, alpha: string) {
    const red = parseInt(hex16rgb.substring(1, 3), 16);
    const green = parseInt(hex16rgb.substring(3, 5), 16);
    const blue = parseInt(hex16rgb.substring(5, 7), 16);
    return `rgba(${red},${green},${blue},${alpha})`;
  }
}
